<template>
  <PlatformLayout>
    <v-card rounded max-width="1366" class="d-block mx-auto">
      <v-card-title>
        <h5 class="text-h5 font-weight-bold text-left">
          Cotizaciones
          <v-icon>mdi-chart-box</v-icon>
        </h5>
      </v-card-title>
      <v-card-text>
        <CotizacionesMetricas />
        <v-card outlined class="mt-4">
          <v-card-title class="text-subtitle-1 font-weight-bold">
            Listado&nbsp;
            <v-icon>mdi-format-list-bulleted</v-icon>
          </v-card-title>
          <v-card-text>
            <CotizacionesLista />
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </PlatformLayout>
</template>

<script>
import PlatformLayout from "@/components/PlatformLayout.vue";
import CotizacionesMetricas from "@/components/Cotizaciones/CotizacionesMetricas.vue";
import CotizacionesLista from "@/components/Cotizaciones/CotizacionesLista.vue";

export default {
  name: "Cotizaciones",
  components: {
    PlatformLayout,
    CotizacionesMetricas,
    CotizacionesLista,
  },
};
</script>